import { fetchData, apiURL } from './api_helper';

const getSettings = () => new Promise((resolve, reject) => {
  const endpointURL = `${apiURL}/api/users/me/settings`;
  fetchData(endpointURL, 'GET')
    .then((result) => {
      resolve(result.data);
    })
    .catch((error) => {
      reject(error);
    });
});

const setSettings = config => new Promise((resolve, reject) => {
  const endpointURL = `${apiURL}/api/users/me/settings`;
  fetchData(endpointURL, 'POST', config)
    .then((result) => {
      resolve(result.data);
    })
    .catch((error) => {
      reject(error);
    });
});

export default {
  getSettings,
  setSettings
};



// WEBPACK FOOTER //
// ./src/api/settings.js